/* eslint-disable prettier/prettier */ 'use client';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DEFAULT_NUMBER, MAX_NUMBER_OF_MONTHS, MAX_NUMBER_OF_NIGHTS_IB, MAX_ROOMS_ALLOWED, ROOM_CODES, BOOKING_CHANNEL, Area, DATE_TYPE, BOOKING_SUBCHANNEL, URLParams, BUSINESS_BOOKER_USER_ROLES } from '@whitbread-eos/api';
import { DatePickerWithRange as DatePicker } from '@whitbread-eos/atoms/ui';
import { getAuthCookie } from '@whitbread-eos/utils';
import { getSearchRedirectLink, getHotelInformationIB, mapSearchParamsForURL, roomOccupancyParamsForURL, getHotelAvailabilitiesIB, isHotelOpeningSoon, staticHotelInformationIB, getMultiSearchParamsIB, updateSearchParamsIfError, isMoreThan364DaysInFuture, validateRoomOccupancyConditions, getDaysInMonth } from '@whitbread-eos/utils/server';
import { isBefore, startOfDay, add, format } from 'date-fns';
import { nanoid } from 'nanoid';
import { useParams, useSearchParams, useRouter } from 'next/navigation';
import { useState, useEffect } from 'react';
import { Location } from './Location';
import { RoomOccupancy } from './RoomOccupancy';
import SearchButton from './SearchButton';
const defaultRoom = {
    adults: 1,
    children: 0,
    shouldIncludeCot: false,
    roomType: ROOM_CODES.double
};
const Search = ({ mobile = false, formLabels, locale, language, addRoomIcon, icons, userRole, globalLabels, hideEditSearch = ()=>{
    return;
}, onOpenChange = ()=>{
    return;
} })=>{
    const idTokenCookie = getAuthCookie();
    const router = useRouter();
    //prefill functionality
    const { slug } = useParams();
    const searchParams = useSearchParams();
    const hotelFullSlug = slug ? `/hotels/${Array.isArray(slug) ? slug.join('/') : slug}` : undefined;
    const searchParamsObj = {};
    searchParams.forEach((value, key)=>{
        searchParamsObj[key] = value;
    });
    var _searchParamsObj_searchModelsearchTerm;
    const locationFromUrl = (_searchParamsObj_searchModelsearchTerm = searchParamsObj['searchModel.searchTerm']) !== null && _searchParamsObj_searchModelsearchTerm !== void 0 ? _searchParamsObj_searchModelsearchTerm : '';
    //end of prefill functionality
    const [location, setLocation] = useState('');
    const [selectedLocation, setSelectedLocation] = useState({});
    const [rooms, setRooms] = useState({
        [nanoid()]: defaultRoom
    });
    const [showLocationError, setShowLocationError] = useState(false);
    const [showCalendarError, setShowCalendarError] = useState(false);
    const [showRoomOccupancyError, setShowRoomOccupancyError] = useState(false);
    const [locationOpen, setLocationOpen] = useState(false);
    const [datePickerOpen, setDatePickerOpen] = useState(false);
    const [roomOccupancyOpen, setRoomOccupancyOpen] = useState(false);
    useEffect(()=>{
        onOpenChange(locationOpen || datePickerOpen || roomOccupancyOpen);
    }, [
        locationOpen,
        datePickerOpen,
        roomOccupancyOpen
    ]);
    useEffect(()=>{
        if (showCalendarError || showRoomOccupancyError || showLocationError) {
            hideEditSearch === null || hideEditSearch === void 0 ? void 0 : hideEditSearch();
        }
    }, [
        showCalendarError,
        showRoomOccupancyError,
        showLocationError
    ]);
    const [date, setDate] = useState({
        from: undefined,
        to: undefined
    });
    const [dateFromUrl, setDateFromUrl] = useState({
        from: undefined,
        to: undefined
    });
    const handleDateChange = (newDate)=>{
        setDate(newDate);
    };
    const handleUpdateRoom = (id, newData)=>{
        setRooms((initialRooms)=>_object_spread_props(_object_spread({}, initialRooms), {
                [id]: _object_spread({}, newData)
            }));
        setShowRoomOccupancyError(false);
    };
    const handleAddRoom = ()=>{
        if (Object.keys(rooms).length < MAX_ROOMS_ALLOWED) {
            setRooms((initialRooms)=>_object_spread_props(_object_spread({}, initialRooms), {
                    [nanoid()]: defaultRoom
                }));
            setShowRoomOccupancyError(false);
        }
    };
    const handleRemoveRoom = (roomId)=>{
        setRooms((initialRooms)=>{
            return Object.fromEntries(Object.entries(initialRooms).filter(([id])=>id !== roomId));
        });
        setShowRoomOccupancyError(false);
    };
    const parseDateString = (dateStr)=>{
        return new Date(dateStr);
    };
    useEffect(()=>{
        const getData = function() {
            var _ref = _async_to_generator(function*() {
                if (slug && hotelFullSlug) {
                    const hotelInformationSlug = yield staticHotelInformationIB(hotelFullSlug, language);
                    var _hotelInformationSlug_name;
                    setLocation((_hotelInformationSlug_name = hotelInformationSlug === null || hotelInformationSlug === void 0 ? void 0 : hotelInformationSlug.name) !== null && _hotelInformationSlug_name !== void 0 ? _hotelInformationSlug_name : '');
                }
            });
            return function getData() {
                return _ref.apply(this, arguments);
            };
        }();
        if (slug && hotelFullSlug || locationFromUrl) {
            const { arrival, departure, rooms: roomsFromUrl } = getMultiSearchParamsIB(searchParamsObj);
            setRooms(roomsFromUrl);
            setLocation(locationFromUrl !== null && locationFromUrl !== void 0 ? locationFromUrl : '');
            setDateFromUrl({
                from: parseDateString(arrival),
                to: parseDateString(departure)
            });
        }
        getData();
    }, [
        slug,
        hotelFullSlug,
        language,
        locationFromUrl
    ]);
    const numberOfNightsURLError = searchParamsObj.NIGHTS !== undefined && (isNaN(Number(searchParamsObj.NIGHTS)) || Number(searchParamsObj.NIGHTS) < DEFAULT_NUMBER || Number(searchParamsObj.NIGHTS) > MAX_NUMBER_OF_NIGHTS_IB);
    const day = searchParamsObj.ARRdd;
    const month = searchParamsObj.ARRmm;
    const year = searchParamsObj.ARRyyyy;
    const startDate = new Date(Number(year), Number(month) && Number(month) - 1, Number(day));
    const today = startOfDay(new Date());
    const dateIsValid = day !== undefined || month !== undefined || year !== undefined;
    const dateIsInPastOrFutureError = dateIsValid && (isBefore(startDate, today) || isMoreThan364DaysInFuture(startDate, today));
    const dateIsNotNumberError = dateIsValid && (isNaN(Number(day)) || isNaN(Number(month)) || isNaN(Number(year)));
    const daysInMonth = getDaysInMonth(Number(month), Number(year));
    const dateFormattedHasError = dateIsValid && (Number(month) < DEFAULT_NUMBER || Number(month) > MAX_NUMBER_OF_MONTHS || Number(day) < DEFAULT_NUMBER || Number(day) > daysInMonth);
    const numberOfRooms = Number(searchParamsObj.ROOMS);
    let roomOccupancyError = false;
    const selfBookerCondition = userRole === BUSINESS_BOOKER_USER_ROLES.SELF && numberOfRooms > DEFAULT_NUMBER;
    if (searchParamsObj.ROOMS && (isNaN(numberOfRooms) || numberOfRooms < DEFAULT_NUMBER || numberOfRooms > MAX_ROOMS_ALLOWED || selfBookerCondition)) {
        roomOccupancyError = true;
    }
    if (!selfBookerCondition) {
        for(let roomIndex = 1; roomIndex <= numberOfRooms; roomIndex++){
            const adultKey = `${URLParams.adult}${roomIndex}`;
            const childKey = `${URLParams.child}${roomIndex}`;
            const cotKey = `${URLParams.cot}${roomIndex}`;
            const roomTypeKey = `${URLParams.roomType}${roomIndex}`;
            const adult = searchParams.get(adultKey);
            const child = searchParams.get(childKey);
            const cot = searchParams.get(cotKey);
            const roomType = searchParams.get(roomTypeKey);
            roomOccupancyError = validateRoomOccupancyConditions(adult, child, roomType, cot);
        }
    }
    useEffect(()=>{
        if (numberOfNightsURLError || dateIsInPastOrFutureError || dateIsNotNumberError || dateFormattedHasError) {
            setShowCalendarError(true);
            setDate({
                from: undefined,
                to: undefined
            });
            setDateFromUrl({
                from: undefined,
                to: undefined
            });
        }
        if (roomOccupancyError) {
            setShowRoomOccupancyError(true);
            setRooms({
                [nanoid()]: defaultRoom
            });
        }
        const result = updateSearchParamsIfError(searchParams, userRole);
        if (result.shouldUpdate) {
            router.replace(result.url);
        }
    }, [
        searchParams,
        numberOfNightsURLError,
        dateIsInPastOrFutureError,
        dateIsNotNumberError,
        dateFormattedHasError,
        roomOccupancyError,
        userRole,
        router
    ]);
    function handleButtonClick(queryParams) {
        return _handleButtonClick.apply(this, arguments);
    }
    function _handleButtonClick() {
        _handleButtonClick = _async_to_generator(function*(queryParams) {
            var _hotelInformation_links;
            if (!(queryParams === null || queryParams === void 0 ? void 0 : queryParams.searchTerm)) {
                setShowLocationError(true);
                return;
            }
            const country = language === 'en' ? 'gb' : 'de';
            const hotelId = queryParams.code;
            const paramsMappedForURL = mapSearchParamsForURL(queryParams);
            const roomOccupancyParams = roomOccupancyParamsForURL(queryParams);
            const hotelInformation = yield getHotelInformationIB(hotelId, language);
            const hotelSlugInformation = hotelInformation === null || hotelInformation === void 0 ? void 0 : (_hotelInformation_links = hotelInformation.links) === null || _hotelInformation_links === void 0 ? void 0 : _hotelInformation_links.detailsPage;
            const startDate = new Date(Number(queryParams.ARRyyyy), Number(queryParams.ARRmm && queryParams.ARRmm - 1), Number(queryParams.ARRdd));
            const endDate = add(startDate, {
                days: Number(queryParams.nights)
            });
            const hotelAvailabilitiesParams = {
                hotelId: hotelId,
                arrival: format(startDate, DATE_TYPE.YEAR_MONTH_DAY),
                departure: format(endDate, DATE_TYPE.YEAR_MONTH_DAY),
                brand: Area.PI,
                country: country,
                rooms: queryParams.rooms.map((room)=>({
                        adultsNumber: room.adults,
                        childrenNumber: room.children,
                        cotRequired: room.shouldIncludeCot,
                        roomType: room.roomType
                    })),
                language: language,
                bookingChannel: {
                    channel: BOOKING_CHANNEL.BB,
                    language: language === null || language === void 0 ? void 0 : language.toUpperCase(),
                    subchannel: BOOKING_SUBCHANNEL.WEB
                },
                channel: BOOKING_CHANNEL.BB
            };
            const hotelAvailabilities = yield getHotelAvailabilitiesIB(hotelAvailabilitiesParams.hotelId, hotelAvailabilitiesParams.arrival, hotelAvailabilitiesParams.departure, hotelAvailabilitiesParams.brand, hotelAvailabilitiesParams.country, hotelAvailabilitiesParams.rooms, hotelAvailabilitiesParams.language, hotelAvailabilitiesParams.bookingChannel, hotelAvailabilitiesParams.channel, idTokenCookie);
            const hotelOpeningDate = (hotelInformation === null || hotelInformation === void 0 ? void 0 : hotelInformation.hotelOpeningDate) || '';
            const selectedDate = new Date(`${queryParams.ARRmm}/
      ${queryParams.ARRdd}/
      ${queryParams.ARRyyyy}`);
            let hotelHasAvailability, hotelIsOpeningSoon;
            if (!hotelId) {
                hotelHasAvailability = true;
                hotelIsOpeningSoon = false;
            } else {
                var _hotelAvailabilities_hotelAvailability_roomRates, _hotelAvailabilities_hotelAvailability, _hotelAvailabilities_hotelAvailability1;
                hotelHasAvailability = (hotelAvailabilities === null || hotelAvailabilities === void 0 ? void 0 : (_hotelAvailabilities_hotelAvailability = hotelAvailabilities.hotelAvailability) === null || _hotelAvailabilities_hotelAvailability === void 0 ? void 0 : (_hotelAvailabilities_hotelAvailability_roomRates = _hotelAvailabilities_hotelAvailability.roomRates) === null || _hotelAvailabilities_hotelAvailability_roomRates === void 0 ? void 0 : _hotelAvailabilities_hotelAvailability_roomRates.length) > 0 && (hotelAvailabilities === null || hotelAvailabilities === void 0 ? void 0 : (_hotelAvailabilities_hotelAvailability1 = hotelAvailabilities.hotelAvailability) === null || _hotelAvailabilities_hotelAvailability1 === void 0 ? void 0 : _hotelAvailabilities_hotelAvailability1.available);
                hotelIsOpeningSoon = isHotelOpeningSoon(hotelOpeningDate, selectedDate);
            }
            const URLToRedirect = `ARRdd=${paramsMappedForURL.ARRdd}&ARRmm=${paramsMappedForURL.ARRmm}&ARRyyyy=${paramsMappedForURL.ARRyyyy}&NIGHTS=${paramsMappedForURL.nights}&ROOMS=${paramsMappedForURL.roomsNumber}&${roomOccupancyParams}`;
            window.location.href = yield getSearchRedirectLink(hotelId, hotelHasAvailability, hotelIsOpeningSoon, hotelSlugInformation, language, country, URLToRedirect, paramsMappedForURL, queryParams);
        });
        return _handleButtonClick.apply(this, arguments);
    }
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": mobile ? 'IB-Search-Container-Mobile' : 'IB-Search-Container-Desktop',
        className: `${mobile ? searchMobileStyle : searchStyle}`,
        children: [
            /*#__PURE__*/ _jsx(Location, {
                location: location,
                setLocation: setLocation,
                labels: formLabels,
                selectedLocation: selectedLocation,
                setSelectedLocation: setSelectedLocation,
                icons: icons,
                mobile: mobile,
                globalLabels: globalLabels,
                hideEditSearch: hideEditSearch,
                onOpenChange: (open)=>setLocationOpen(open),
                showError: showLocationError,
                setShowError: (value)=>setShowLocationError(value)
            }),
            (!mobile || location || showCalendarError || showRoomOccupancyError) && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: secondRowStyle,
                        "data-testid": mobile ? 'IB-Search-Container-Mobile-Calendar-and-RoomOccupancy-Container' : 'IB-Search-Container-Desktop-Calendar-and-RoomOccupancy-Container',
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: datePickerContainerStyle,
                                "data-testid": mobile ? 'IB-Search-Container-Mobile-Calendar-Date-Picker' : 'IB-Search-Container-Desktop-Calendar-Date-Picker',
                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                    className: datePickerStyle,
                                    locale: locale,
                                    formLabels: formLabels,
                                    icons: icons,
                                    mobile: mobile,
                                    onDateChange: handleDateChange,
                                    dateFromUrl: dateFromUrl,
                                    showError: showCalendarError,
                                    setShowError: (value)=>setShowCalendarError(value),
                                    onOpenChange: (open)=>setDatePickerOpen(open)
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: roomOccupancyContainerStyle,
                                "data-testid": mobile ? 'IB-Search-Container-Mobile-Room-Occupancy' : 'IB-Search-Container-Desktop-Room-Occupancy',
                                children: /*#__PURE__*/ _jsx(RoomOccupancy, {
                                    formLabels: formLabels,
                                    rooms: rooms,
                                    updateRoom: handleUpdateRoom,
                                    addRoom: handleAddRoom,
                                    removeRoom: handleRemoveRoom,
                                    addRoomIcon: addRoomIcon,
                                    icons: icons,
                                    userRole: userRole,
                                    showError: showRoomOccupancyError,
                                    onOpenChange: (open)=>setRoomOccupancyOpen(open)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(SearchButton, {
                        rooms: rooms,
                        location: selectedLocation,
                        selectedDate: date,
                        handleButtonClick: handleButtonClick,
                        mobile: mobile,
                        formLabels: formLabels,
                        dateFromUrl: dateFromUrl
                    })
                ]
            })
        ]
    });
};
export default Search;
const searchStyle = 'relative flex mobile:hidden ml-9 mr-9 w-full';
const searchMobileStyle = 'hidden mobile:flex mobile:mt-6 mobile:w-full mobile:flex-col';
const datePickerStyle = 'w-full min-w-64 mobile:min-w-[unset] tablet:min-w-56';
const datePickerContainerStyle = 'grow mobile:flex-1 mobile:min-w-[7.25rem]';
const roomOccupancyContainerStyle = 'grow mobile:flex-1 mobile:min-w-[7.25rem]';
const secondRowStyle = 'grow-[6] flex mobile:mt-4 mobile:gap-2';
